import { normalizeTopicsResponse } from './adapters';
import { ITopic } from '../common/types';
import { PYTHON_BACKEND } from '../constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod, HttpStatus } from '../constants/http';

export async function fetchTopics(): Promise<ITopic[] | void> {
  const baseUrl = PYTHON_BACKEND;
  const endpoint = ApiEndpoint.Topics;
  const url = `${baseUrl}/${endpoint}/`;
  const requestOptions = {
    method: HttpMethod.GET,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (!response.ok) {
      if (response.status === HttpStatus.InternalServerError) {
        throw new Error('[api.fetch-topics]: Internal Server Error');
      }
      if (data && data.message) {
        throw new Error(data.message);
      }
      throw new Error('[api.fetch-topics]: Something went wrong!');
    }
    return normalizeTopicsResponse(data);
  } catch (error: unknown) {
    console.error(error);
  }
}
